"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.trimmedTextRenderer = exports.Cell = exports.textWrapId = void 0;
const react_1 = __importStar(require("react"));
const types_1 = require("../types");
const Text_1 = require("../../Text");
const Tooltip_1 = require("../../Tooltip");
const helpers_1 = require("./helpers");
exports.textWrapId = 'grid-text-wrap';
const getTextAlign = (headerJustify) => {
    switch (headerJustify) {
        case types_1.GRID_COLUMN_HEADER_JUSTIFY.left:
            return Text_1.TEXT_ALIGN.left;
        case types_1.GRID_COLUMN_HEADER_JUSTIFY.center:
            return Text_1.TEXT_ALIGN.center;
        case types_1.GRID_COLUMN_HEADER_JUSTIFY.right:
            return Text_1.TEXT_ALIGN.right;
        default:
            return undefined;
    }
};
const Cell = function ({ cellData, columnWidth, bold, contentJustify, tooltipMaxWidth }) {
    const ref = (0, react_1.useRef)(null);
    return (0, Tooltip_1.useTooltip)({
        delayTimeout: 500,
        maxWidth: tooltipMaxWidth || `${columnWidth + 50}px`,
        renderContent: () => react_1.default.createElement(helpers_1.TooltipText, { size: Text_1.TEXT_SIZE.s }, cellData),
        render: (tooltipProps) => {
            return (react_1.default.createElement(Text_1.Text, Object.assign({}, tooltipProps, { ref: ref, "data-selector-id": exports.textWrapId, truncate: true, view: Text_1.TEXT_VIEW.inherit, weight: bold ? Text_1.TEXT_WEIGHT.bold : Text_1.TEXT_WEIGHT.normal, onMouseEnter: (0, helpers_1.onMouseEnterHandlerDecorator)(tooltipProps.onMouseEnter, ref), align: getTextAlign(contentJustify) }), cellData));
        }
    });
};
exports.Cell = Cell;
const trimmedTextRenderer = ({ cellData, columnWidth, bold, disabled, inactive, headerJustify, tooltipMaxWidth }) => {
    if (cellData && columnWidth) {
        return (react_1.default.createElement(exports.Cell, { cellData: cellData, columnWidth: columnWidth, bold: bold, disabled: disabled, inactive: inactive, contentJustify: headerJustify, tooltipMaxWidth: tooltipMaxWidth }));
    }
    return null;
};
exports.trimmedTextRenderer = trimmedTextRenderer;
//# sourceMappingURL=trimmedTextRenderer.js.map